<p-columnFilter
  #dtfs
  field="{{field}}"
  matchMode="equals"
  [type]="returnFilterType()"
  display="menu"
  [showApplyButton]="false"
  [showClearButton]="false"
  [showMatchModes]="false"
  [showOperator]="false"
  [showAddButton]="false">
  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
    <p-dropdown
      [options]="filterOptions"
      [ngModel]="value"
      (onChange)="applySelectFilter($event, filter, dtfs)"
      placeholder=""
      optionLabel="label"
      optionValue="value"
    ></p-dropdown>
    <div class="table-column-filter-buttonbar">
      <button pButton (click)="clearFilter(dtfs)" label="Clear" class="filter-button p-element p-button-outlined p-button-sm">
      </button>
    </div>
  </ng-template>
</p-columnFilter>
